// OurStory.js
import React from 'react';
import { motion } from 'framer-motion';

const OurStory = () => {
  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-5xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-6">
              Our Story
            </h2>
          </motion.div>

          {/* Story Content */}
          <div className="space-y-6">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="text-base text-gray-700 font-light leading-relaxed"
            >
              Notapaths was founded in response to the growing complexity surrounding international study and employment opportunities. Many individuals face confusion, misinformation, and unrealistic promises when exploring options abroad, often without clear guidance or reliable support.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="text-base text-gray-700 font-light leading-relaxed"
            >
              Our founders recognised the need for a structured and transparent approach to global mobility. Notapaths was created to bridge this gap by offering professional guidance, practical support, and access to trusted academic and employer networks.
            </motion.p>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="text-base text-gray-700 font-normal leading-relaxed"
            >
              From our early beginnings to where we are today, our focus has remained the same. Help people understand their options clearly, prepare thoroughly, and move forward with confidence.
            </motion.p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
